type CsvColumn<T> = {
  key: Extract<keyof T, string>;
  label: string;
};

const escapeCsvValue = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

type KeyOf<T> = Extract<keyof T, string>;

export function downloadCsv<T extends object>(
  filename: string,
  data: T[],
  columns?: Array<CsvColumn<T>>
) {
  if (!data.length) return;

  const headers =
    columns?.map((col) => col.label) ??
    Object.keys(data[0]).map((key) => key.toString());

  const keys =
    columns?.map((col) => col.key) ??
    (Object.keys(data[0]) as Array<KeyOf<T>>);

  const rows = data.map((row) =>
    keys
      .map((key) => {
        const record = row as Record<KeyOf<T>, unknown>;
        return escapeCsvValue(record[key] ?? "");
      })
      .join(",")
  );

  const csvContent = [headers.join(","), ...rows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
